import axios from "axios";
import { API_ROUTE, headersRequest } from "../../helpers";

export const PerformanceServices = {
  getUserByOrganization: async () => {
    try {
      const result = await axios.get(`${API_ROUTE}users`, headersRequest());
      if (result.status == 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("Error al cargar los datos");
    }
  },

  getDataByFilter: async (data) => {
    try {
      const result = await axios.get(
        `${API_ROUTE}productivity-panel-filter?Cluster=${data.IdCluster}&Rol=${data.Idrol}&Position=${data.position}&Name=${data.IdUser}&StartDate=${data.start_date}&EndDate=${data.end_date}`,
        headersRequest()
      );
      if (result.status == 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("Error al cargar los datos");
    }
  },
  getTasksByResource: async () => {
    try {
      const result = await axios.get(
        `${API_ROUTE}dashboard-resources-activities`,
        headersRequest()
      );
      if (result.status == 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("Error al cargar los datos");
    }
  },
  getAllProjects: async () => {
    try {
      const result = await axios.get(`${API_ROUTE}projects`, headersRequest());
      if (result.status == 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("Error al cargar los del proyecto");
    }
  },
  getCluster: async () => {
    try {
      const result = await axios.get(
        `${API_ROUTE}edit-project-ddls`,
        headersRequest()
      );
      if (result.status == 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("Error al cargar los DDL del proyecto");
    }
  },
  getUserByOrganizationCluster: async (IdCluster) => {
    try {
      const result = await axios.get(
        `${API_ROUTE}users-cluster/${IdCluster}`,
        headersRequest()
      );
      if (result.status == 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("Error al cargar los datos");
    }
  },
  getDataClusterByFilter: async (data) => {
    try {
      const result = await axios.get(
        `${API_ROUTE}delivery-dashboard-users-cluster-ocupation?Cluster=${data.IdCluster}&Rol=${data.Idrol}&Position=${data.position}&IdUsuario=${data.IdUser}&StartDate=${data.start_date}&EndDate=${data.end_date}`,
        headersRequest()
      );
      if (result.status === 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("Error al cargar los datos");
    }
  },
  getDataClusterHistogram: async (data) => {
    try {
      const result = await axios.get(
        `${API_ROUTE}delivery-dashboard-users-cluster-ocupation-histogram?Cluster=${data.IdCluster}&StartDate=${data.start_date}&EndDate=${data.end_date}`,
        headersRequest()
      );
      if (result.status === 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("Error al cargar los datos");
    }
  },
};
